import {GuideBox} from 'diagram-js/lib/model';
import {RichTextUtils} from '@ispm/shared/classes/RichTextUtils';
import {isEmpty} from "lodash";
import {RichTextConstants} from '@ispm/shared/classes/RichTextConstants';

export class GuidedBoxPayload {
  guidingText: string;
  isAlert: boolean;
  hyperlinks: string[];
  attachments: string[];
  stripText: string;

  constructor(initialData?: GuideBox) {
    if (initialData) {
      this.guidingText = this.formatGuideText(initialData.guidingText);
      this.stripText = RichTextUtils.stripTags(this.guidingText);
      this.isAlert = initialData.automatically;
      this.hyperlinks = initialData.hyperlinks;
      this.attachments = initialData.attachments;
    }
  }

  private formatGuideText(richText): string {
    if (!richText) {
      return richText;
    }
    if (RichTextUtils.richTextIsHTML(richText)) {
      return richText;
    }
    return RichTextUtils.convertTextToHTML(richText);
  }

  getGuideTextWithLinks(): string {
    const hyperlinks = this.hyperlinks ?? [];
    const guidingText = this.guidingText ?? '';
    return guidingText + hyperlinks.map(link => {
      return `<p><a href="${link}" rel="noopener noreferrer" target="_blank">${link}</a></p>`;
    }).join('');
  }

  private containsHeading(): boolean {
    return RichTextUtils.containsHeading(this.guidingText);
  }

  private isLongText(): boolean {
    return this.guidingText.length >= 185;
  }

  public textIsFitInScreen(): boolean {
    return !(this.isLongText() || this.containsHeading());
  }

  public textIsOnlyOneLine(): boolean {
    return RichTextUtils.textIsOnlyOneLine(this.guidingText);
  }

  public needShowMore(): boolean {
    return !this.textIsOnlyOneLine() || this.containsAttachments();
  }

  public getFirstSentence(): string {
    if (isEmpty(this.stripText.trim())) {
      return RichTextConstants.PlaceHolderForOnlyAttachments;
    }
    return RichTextUtils.getFirstSentence(this.guidingText);
  }

  public containsAttachments(): boolean {
    return this.attachments.length > 0;
  }
}
